import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";

function Offer3NiwelacjaTerenu() {
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/niwelacja-terenu-2-1.jpeg"
          alt="Niwelacja terenu - wyrównanie działki - Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Niwelacja terenu i skarpowanie działek pod budowę Gdańsk, Gdynia
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Precyzyjne wyrównywanie i profilowanie gruntu na Kaszubach
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Odpowiednie ukształtowanie i wyrównanie gruntu to fundament pod bezpieczną budowę domu oraz estetyczny ogród. DRZEWUS realizuje profesjonalną niwelację terenu minikoparkami i ładowarkami na terenie Gdańska, Gdyni, Wejherowa, Kartuz oraz Kaszub. Usuwamy nierówności, korygujemy spadki i przygotowujemy podłoże pod <a href="/zakladanie-ogrodu/trawa-z-rolki" className="underline hover:opacity-80">trawniki z rolki</a> oraz infrastrukturę budowlaną.
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Wyrównanie terenu pod dom, halę i inwestycję
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Przygotowanie działki i terenu pod fundamenty
            </a>
            <a
              href="#3"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Niwelacja działki przed zakładaniem ogrodu i trawnika
            </a>
            <a
              href="#4"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Ile kosztuje niwelacja terenu?
            </a>
          </div>
          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <h2 id="1">Wyrównanie terenu pod dom, halę i inwestycję</h2>
          <p>
            Większość działek wymaga równania terenu. Mało która działka jest
            idealnie płaska. Dlatego warto zlecić równanie terenu pod budowę, co
            ułatwi późniejsze prace. Możliwa jest też niwelacja terenu na
            działce rolnej, co korzystnie wpłynie na uprawy.
          </p>
          <p>
            Przed założeniem trawnika lub ogrodu dobrze jest wyrównać podłoże.
            Taki zabieg jest też potrzebny po mulczowaniu. Jeśli posiadasz teren
            pod inwestycje, wykonanie niwelacji terenu może zwiększyć jego
            wartość. Równa działka będzie wyglądać o wiele korzystniej, co
            pomoże w szybszej sprzedaży.
          </p>
          <p>
            Przydatne jest również wyrównanie terenu pod taras. Można wtedy
            wykonać odpowiednie nachylenie podłoża, które ułatwi wykonanie
            tarasu i zapobiegnie gromadzeniu się na nim wody.
          </p>
          <p>
            Jeśli chcesz mieć na działce basen wolnostojący, warto odpowiednio
            przygotować miejsce, w którym go postawisz. Jest to szczególnie
            ważne, jeśli teren jest nierówny lub ze spadkiem.
          </p>

          <p>Zakres naszych prac niwelacyjnych:</p>
          <ul>
            <li>niwelacja terenu pod trawnik</li>
            <li>niwelacja terenu pod ogród</li>
            <li>wyrównanie terenu pod budowę</li>
            <li>równanie działki po budowie</li>
            <li>przygotowanie terenu pod oczko wodne</li>
            <li>równanie terenu pod taras</li>
            <li>przygotowanie terenu pod basen</li>
          </ul>

          <h2 id="2">Przygotowanie działki i terenu pod fundamenty</h2>
          <p>
            Niwelacja terenu to inaczej wyrównanie działki. Niwelowanie polega
            na usunięciu nadmiaru ziemi w jednych miejscach, a uzupełnieniu
            braków w innych. Dzięki temu uzyskasz idealnie równą powierzchnię,
            co ułatwi dalsze prace na działce, bez względu na to, czy będzie to
            budowa, zakładanie ogrodu, czy trawnika.
          </p>
          <p>
            Miejsce pod ogród nie zawsze musi być płaskie. Skorzystaj z naszego
            doświadczenia w zakładaniu ogrodów. Podpowiemy Ci, jak najlepiej
            ukształtować teren pod rośliny, które chcesz posadzić. Możesz też
            zlecić nam wszelkie prace związane z ogrodem.
          </p>

          <h2 id="3">Niwelacja działki przed zakładaniem ogrodu i trawnika</h2>
          <p>
            Jeśli chcesz cieszyć się równym trawnikiem, to przed jego założeniem
            trzeba odpowiednio przygotować podłoże. Dzięki temu nie będzie
            później problemów z jego koszeniem.
          </p>
          <p>
            Równy teren jest ważny przy układaniu trawy z rolki, choć nie musi
            być on wyłącznie poziomy. Trawę można ułożyć również na skarpie.
            Przy siewie trawy także potrzebne jest równe podłoże. Choć może się
            wydawać, że łatwo to zrobić samemu, w rzeczywistości jest to bardzo
            pracochłonne.
          </p>
          <p>
            Mechaniczna niwelacja terenu jest dokładniejsza. Zleć ją nam, a
            wykonamy to szybko i solidnie. Oferujemy również zakładanie
            trawników, więc możemy zająć się tym dla Ciebie od A do Z.
          </p>

          <h2 id="4">Ile kosztuje niwelacja terenu?</h2>
          <p>
            Cena jest ustalana w zależności od ukształtowania terenu działki.
            Ważna jest też wielkość powierzchni, która ma być wyrównana.
            Kolejnym czynnikiem jest położenie działki, co wiąże się z kosztami
            dojazdu. Wypełnij prosty formularz, aby poznać cenę za niwelację
            Twojej działki. Odpowiesz tam na kilka prostych pytań, a jeśli
            możesz, dołącz zdjęcia. Ułatwi to wycenę. Jeśli potrzebne nam będzie
            więcej informacji, umówimy się na oględziny działki.
          </p>
          <p>
            Nie czekaj – już dziś skontaktuj się z nami, aby otrzymać bezpłatną
            wycenę. Skorzystaj z naszych usług i ciesz się równą działką. Możemy
            Cię zapewnić, że będziesz zadowolony z efektów naszej pracy.
          </p>
        </div>
      </section>
      {/* PORTFOLIO */}
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col items-center justify-center mb-6">
          <h2 className="uppercase color-yellow text-xl text-center">
            Nasze realizacje
          </h2>
          <h3 className="text-3xl lg:text-5xl color-green text-center">
            Spójrz jak pomogliśmy<br></br>
            <span className="color-yellow">naszym Klientom</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/niwelacjaterenu-0.jpeg"
              alt="Niwelacja terenu - realizacja Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/niwelacjaterenu-1.jpeg"
              alt="Niwelacja terenu - realizacja Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/niwelacjaterenu-3.jpeg"
              alt="Niwelacja terenu - realizacja Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/niwelacja-rownanie-1.jpeg"
              alt="Niwelacja i równanie terenu - realizacja Drzewus nr 4"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/niwelacja-rownanie-2.jpg"
              alt="Niwelacja i równanie terenu - realizacja Drzewus nr 5"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/niwelacja-rownanie-3.jpg"
              alt="Niwelacja i równanie terenu - realizacja Drzewus nr 6"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/niwelacja-terenu-1-1.jpeg"
              alt="Niwelacja terenu - realizacja Drzewus nr 7"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Offer3NiwelacjaTerenu;